import styled from "styled-components";
import { windowWidth } from "@styles/global";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  height: 100vh;
`;

const NavbarContainer = styled.div`
  width: 100%;
`;

const ContentContainer = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  overflow: hidden;

  > :first-child {
    min-width: 55px;

    @media ( max-width: ${windowWidth.tablet} ) {
      display: none;
    }
  }
`;

const Content = styled.div`
  flex-grow: 1;
  height: 100%;
  color: ${(props) => props.theme.colors.text};
  background: ${(props) => props.theme.brand.bg};
  overflow: hidden;
`;

export { Container, NavbarContainer, ContentContainer, Content };
